import React from 'react';
import { Building2 } from 'lucide-react';
import { IITH, SERIF, SANS } from '@/pages/landing/iithBrand';

export default function LoginTenantGate() {
  return (
    <div
      className="min-h-[100dvh] flex items-center justify-center px-4"
      style={{
        background:
          `radial-gradient(ellipse 70% 50% at 80% 10%, ${IITH.saffron}33 0%, transparent 55%),` +
          ` linear-gradient(160deg, ${IITH.ink} 0%, ${IITH.navy} 50%, ${IITH.navyMid} 100%)`,
      }}
      data-testid="login-tenant-required-gate"
    >
      <div className="w-full max-w-md text-center text-white">
        <div className="h-16 w-16 rounded-2xl bg-white/10 backdrop-blur flex items-center justify-center mx-auto mb-5 ring-1 ring-white/20">
          <Building2 className="h-8 w-8" />
        </div>
        <h1 className="text-3xl font-semibold mb-3" style={{ fontFamily: SERIF }}>Clinic required</h1>
        <p className="text-[#9AADBE] leading-relaxed mb-6" style={{ fontFamily: SANS }}>
          Open this page from your clinic link — it includes a
          <span className="font-mono text-white"> ?tenant=&lt;slug&gt; </span>
          tag or clinic subdomain.
        </p>
        <div className="bg-white/5 rounded-xl border border-white/10 p-4 mb-6 text-left">
          <p className="text-[11px] uppercase tracking-wider text-white/50 mb-1.5">Example</p>
          <p className="font-mono text-sm break-all">
            {window.location.origin}/login?tenant=<span style={{ color: IITH.gold }}>your-clinic</span>
          </p>
        </div>
        <a
          href="/signup"
          className="inline-block px-5 py-2.5 rounded-lg text-sm font-semibold text-white"
          style={{ background: IITH.saffron, fontFamily: SANS }}
          data-testid="login-gate-create-clinic"
        >
          Create a clinic →
        </a>
      </div>
    </div>
  );
}
